import { stateSelfInfo, stateVipLevels, stateVipState } from './dataStore';
import { toObservable } from './rxjs-utils';
import { combineLatest, map } from 'rxjs';
import { derived } from 'svelte/store';
/** Observable of the current user's rank display string from API (`vipRank`). */
export const getUserFullRank = () => combineLatest([toObservable(stateSelfInfo), toObservable(stateVipState)]).pipe(map(([si, vs]) => (si?.vipRank?.trim() || vs?.vipRank?.trim() || '')));
export const getNextRanks = (position = 1) => combineLatest([toObservable(stateVipLevels), toObservable(stateVipState)]).pipe(map(([_stateVipLevels, _stateVipState]) => {
    if (!_stateVipState || !_stateVipLevels) {
        return [];
    }
    return _stateVipLevels
        .filter((vipLevel) => vipLevel.levelNum > _stateVipState.levelNum ||
        (vipLevel.levelNum === _stateVipState.levelNum &&
            vipLevel.sublevelNum > _stateVipState.sublevelNum))
        .slice(0, position);
}));
/** Observable of the next rank display string from API (`nextRank`). */
export const getUserNextFullRank = () => combineLatest([toObservable(stateSelfInfo), toObservable(stateVipState)]).pipe(map(([si, vs]) => (si?.nextRank?.trim() || vs?.nextRank?.trim() || '')));
export const nextSubLevelRank = derived([stateVipLevels, stateVipState], ([$stateVipLevels, $stateVipState]) => {
    const nextRankIndex = $stateVipLevels.findIndex((vipLevel) => vipLevel.levelNum === ($stateVipState?.nextLevelNum ?? 0) &&
        vipLevel.sublevelNum === ($stateVipState?.nextSublevelNum ?? 0));
    return $stateVipLevels[nextRankIndex] ?? $stateVipLevels[0];
});
